import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { IMAGES } from '../../lib/images';

export const Hero = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, 400]);
  const scale = useTransform(scrollY, [0, 1000], [1, 1.2]);

  const lineVariants = {
    hidden: { y: '100%', opacity: 0 },
    visible: { 
      y: 0, 
      opacity: 1, 
      transition: { duration: 1.2, ease: [0.76, 0, 0.24, 1] } 
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden bg-black">
      <motion.div 
        style={{ y, scale }}
        className="absolute inset-0 w-full h-full"
      >
        <div className="absolute inset-0 bg-black/40 z-10" />
        <img 
          src={IMAGES.hero[0]} 
          alt="Luxury Event" 
          className="w-full h-full object-cover"
        />
      </motion.div>

      <div className="relative z-20 h-full flex flex-col items-center justify-center text-white px-6">
        <div className="overflow-hidden mb-4">
          <motion.p 
            variants={lineVariants}
            initial="hidden"
            animate="visible"
            className="text-sm md:text-base tracking-[0.3em] uppercase font-light text-white/80"
          >
            Jaipur&apos;s Premier Event Management
          </motion.p>
        </div>
        
        <div className="overflow-hidden text-center mb-12">
          <motion.h1 
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            transition={{ duration: 1.4, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
            className="font-editorial text-5xl md:text-8xl lg:text-9xl leading-none text-white tracking-tight"
          >
            Where Nothing <br/>
            <span className="italic font-light text-white/90">Goes Wrong</span>
          </motion.h1>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
          className="flex gap-12 text-center border-t border-white/20 pt-8 mt-12 w-full max-w-4xl justify-between"
        >
          {[
            ['7+ Years', 'Experience'],
            ['410+', 'Events Delivered'],
            ['250+', 'Team Members'],
            ['75+', 'Venues']
          ].map(([stat, label], i) => (
            <div key={i} className="flex flex-col gap-2">
              <span className="text-2xl md:text-4xl font-editorial">{stat}</span>
              <span className="text-xs uppercase tracking-widest text-white/60">{label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
